{{ text | stripHtml }}
<ng-container *ngIf="secondText">
  <p class="my-0 content is-small has-text-grey-dark">
    {{ secondText | stripHtml }}
  </p>
</ng-container>
